import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA v3
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Limpa service workers antigos
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(reg => reg.unregister());
    });
    
    // Regista novo
    setTimeout(() => {
      navigator.serviceWorker.register('/sw.js?v=3')
        .then((registration) => {
          console.log('Nzadi Fit PWA v3');
          registration.update();
        })
        .catch(() => {});
    }, 1000);
  });
}
